import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { useSite } from '../context/SiteContext';

const CaseStudies = () => {
  const { caseStudies = [] } = useSite();
  return (
    <section id="cases" className="section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="text-xs uppercase tracking-[0.24em] text-brand-pink-light">Proof in action</p>
            <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white leading-tight">
              Selected case studies.
            </h2>
          </div>
          <p className="max-w-md text-slate-400">
            A few examples of how we’ve helped businesses modernize operations and delight
            their customers.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {caseStudies.map((c) => (
            <article
              key={c.title}
              className="group rounded-2xl p-6 border border-white/8 bg-white/[0.02] card-lift relative overflow-hidden"
            >
              <div
                aria-hidden
                className="absolute -top-16 -right-16 h-40 w-40 rounded-full bg-brand-green/10 blur-3xl"
              />
              <div className="flex items-center justify-between">
                <span className="text-[11px] uppercase tracking-widest text-brand-green-light">
                  {c.industry}
                </span>
                <ArrowUpRight className="h-4 w-4 text-slate-400 group-hover:text-brand-green-light btn-transition" />
              </div>
              <h3 className="mt-4 text-white text-lg font-semibold leading-snug">{c.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{c.description}</p>
              <div className="mt-6 rounded-lg border border-brand-pink/25 bg-brand-pink/[0.06] p-3">
                <div className="text-[10px] uppercase tracking-widest text-slate-400">Outcome</div>
                <div className="mt-1 text-brand-pink-light font-medium text-sm">{c.outcome}</div>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {c.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[11px] px-2 py-0.5 rounded-md bg-white/[0.04] border border-white/8 text-slate-300"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;
